import axios, { AxiosResponse } from 'axios';
import { ActionTree} from 'vuex';
import {RootState} from '@/store/types';
import {TemplateItem, TemplatesState, TemplatesFilterParams} from './types';
import {directDownload} from "@/utils/download-helper";
import { TransportItem } from '@/store/transport/types';


export const actions: ActionTree<TemplatesState, RootState> = {
  async getTemplates({commit}, data: {filter: TemplatesFilterParams, transport: string}) {
    // commit('setLoading', true);
    try {
      // TODO replace тоже надо будет убрать после приведение mail notify в единый формат
      const resp:AxiosResponse<{templates: TemplateItem[]}> = await axios({
        url: `/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates`,
        params: data.filter,
      })
      if (data.filter?.page_number > 1) {
        commit("pushToStateTemplates", resp.data.templates);
      } else {
        commit('setTemplates', resp.data.templates);
      }
      return resp.data.templates;
    } finally {
      commit('setLoading', false);
    }
  },
  async exportTemplates({commit, dispatch}, data: {filter: TemplatesFilterParams, transport: string}) {
    return await directDownload(`/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates/export`, data.filter)
  },
  async getMultichannelTemplates({commit}, data: {filter: TemplatesFilterParams, transport: string}) {
    // commit('setLoading', true);
    commit(`setMultichannelTemplates`, []);
    try {
      const resp:AxiosResponse<{templates: TemplateItem[]}> = await axios({
        url: `/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates`,
        params: data.filter,
      })
      commit(`setMultichannelTemplates`, resp?.data?.templates);
      return resp?.data?.templates;
    } finally {
      commit('setLoading', false);
    }
  },
  async getTemplateItem({commit, dispatch}, data: {id: number, transport: string}){
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<TemplateItem> = await axios({
        url: `/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates/${data.id}`,
        params: {cache: Math.random()},
      })
      const template = resp.data;
      template.id = data.id;
      commit(`setTemplateItem`, template);
      return template;
    } finally {
      commit('setLoading', false);
    }
  },
  async saveTemplate({commit, dispatch}, data: {item: TemplateItem, transport: string}) {
    commit('setLoading', true);
    try {
      data.item.send_evenly = data.item.send_evenly ?? 0
      data.item.save_text = data.item.save_text ?? 0
      const resp:AxiosResponse<any> = await axios({
        method: data.item.id ? 'put' : 'post',
        url: `/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getTemplates',{transport: data.transport});
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },
  async deleteTemplate({commit, dispatch}, data: {item: TemplateItem, transport: string}) {
    commit('setLoading', true);
    try {
      const resp:AxiosResponse<any> = await axios({
        method: 'delete',
        url: `/acapi/${data.transport.toLowerCase().replace(' ','_')}/templates/${(data.item.id ?? '')}`,
        data: data.item,
      })
      dispatch('getTemplates',{transport: data.transport});
      return resp;
    } finally {
      commit('setLoading', false);
    }
  },

};
